var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.action ? _c('div', {
    attrs: {
      "id": "bio-material-entity-form",
      "data-test": "bio-material-form"
    }
  }, [!_vm.isInModal ? _c('h2', {
    attrs: {
      "id": "bio-material-type-title"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.pageTitle) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm.canShowEntityDetails() ? _c('details-field-group', {
    attrs: {
      "id": _vm.uuid,
      "label": "Library Details",
      "is-bio-styling": true,
      "collapsed": true
    }
  }, [_c('BioMaterialView', {
    attrs: {
      "material-type": _vm.materialType,
      "uuid": _vm.uuid,
      "hide-title": true,
      "group-nid": _vm.groupNid,
      "omit-fields": _vm.editFields,
      "show-add-to-library": false,
      "bio-material-data": _vm.response,
      "show-library-style": true
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('details-field-group', {
    attrs: {
      "id": "edit-material",
      "label": _vm.modificationsTitles,
      "is-bio-styling": true,
      "collapsed": false
    }
  }, [_c('b-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submitEntity.apply(null, arguments);
      }
    }
  }, [_vm._l(_vm.bundleFieldsSorted, function (fieldData) {
    return _c('div', [_vm.isAutocompleteField(fieldData) ? _c('raft-autocomplete', {
      key: fieldData.field_name + 'autocomplete',
      ref: "autocomplete",
      refInFor: true,
      attrs: {
        "field-class": "entity-reference-field",
        "id": fieldData.field_name,
        "name": fieldData.field_name,
        "value": _vm.selectedPlasmidVector,
        "label": fieldData.label,
        "element-id": "plasmid-vector-autocomplete",
        "placeholder": "Add Plasmid/Vector Type",
        "source": _vm.plasmidVectorLookup,
        "results-display": _vm.formattedResultsDisplay,
        "input-class": "form-control",
        "default-value": _vm.autocompleteDefaultValue(fieldData),
        "aria-label": "Plasmid/vector selector"
      },
      on: {
        "selected": _vm.updateSelectedPlasmidVector
      },
      scopedSlots: _vm._u([{
        key: "action",
        fn: function () {
          return [_c('div', {
            staticClass: "copy-plasmid-vector-btn"
          }, [_vm.showCopyPlasmidVectorButton ? _c('b-button', {
            on: {
              "click": _vm.copyPlasmidVectorModifications
            }
          }, [_vm._v("\n                Copy Genetic Modifications\n              ")]) : _vm._e()], 1)];
        },
        proxy: true
      }], null, true)
    }) : _vm.showField(fieldData) ? _c('entity-form-field', {
      key: fieldData.field_name,
      attrs: {
        "field-data": fieldData,
        "entity": _vm.entity,
        "parent-value": _vm.formData[fieldData.field_name],
        "entity-type": "bio_material",
        "bundle": _vm.materialType,
        "placeholder": _vm.getPlaceholder(fieldData.field_name),
        "no-default-value": _vm.isUuidPresent
      },
      on: {
        "disable-form-submit": function ($event) {
          _vm.submitDisabled = true;
        },
        "form-error-message": _vm.catchFormError,
        "update-form-data": _vm.updateFormData
      }
    }) : _vm._e()], 1);
  }), _vm._v(" "), _c('div', {
    staticClass: "bio-material-action-buttons"
  }, [_c('div', {
    staticClass: "buttons-left"
  }, [_vm.showRemoveFromGroupButton && _vm.isInModal ? _c('v-button', {
    staticClass: "clear small",
    attrs: {
      "id": "modal-remove-from-group"
    },
    on: {
      "click": _vm.removeMaterialInModal
    }
  }, [_c('img', {
    staticClass: "remove-icon",
    attrs: {
      "alt": "trash",
      "src": _vm.trashSrc
    }
  }), _vm._v("\n            Remove from " + _vm._s(_vm.inGroup ? "Group" : "Library") + "\n          ")]) : _vm._e(), _vm._v(" "), _vm.showRemoveFromGroupButton && !_vm.isInModal ? _c('v-button', {
    staticClass: "clear small",
    attrs: {
      "id": "modal-remove-from-group"
    }
  }, [_c('img', {
    staticClass: "remove-icon",
    attrs: {
      "alt": "trash",
      "src": _vm.trashSrc
    }
  }), _vm._v(" "), _c('b-link', {
    attrs: {
      "href": _vm.removeLink
    }
  }, [_vm._v("\n              Remove from " + _vm._s(_vm.inGroup ? "Group" : "Library") + "\n            ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "buttons-right"
  }, [_vm.showRemoveFromGroupButton && _vm.isInModal ? _c('v-button', {
    staticClass: "clear small",
    attrs: {
      "id": "modal-add-without-changes"
    },
    on: {
      "click": _vm.addWithoutChanges
    }
  }, [_vm._v("Add Without Changes\n          ")]) : _vm._e(), _vm._v(" "), !_vm.isInModal ? _c('v-button', {
    staticClass: "clear small"
  }, [_c('b-link', {
    staticClass: "cancel",
    attrs: {
      "href": "/"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.cancel.apply(null, arguments);
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.cancelText) + "\n            ")])], 1) : _vm._e(), _vm._v(" "), _c('v-button', {
    class: _vm.disableButton,
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Apply ")])], 1)])], 2)], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }